import { tafMiddlewareManager } from "../helper";
import { timeMiddleware } from "./time";
import { userIdMiddleware } from "./userId";

// 注册中间件
export const initMiddlewareManager = () => {
  [timeMiddleware, userIdMiddleware].forEach(middleware => {
    tafMiddlewareManager.use(middleware);
  });
};
